<template>
  <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
        <div class="content-wrapper">
          <!-- <vs-input class="inputx tree-search-input float-left mr-2" placeholder="Search..." v-model.lazy="searchword" />
          <vs-button color="primary" type="filled" @click="search" class="mb-3">Search</vs-button> -->
          <!-- <v-tree ref='tree' :canDeleteRoot="true" :data='treeData' :draggable='true' :tpl='tpl' :halfcheck='true' :multiple="true"/> -->
          <div>
            <!-- <button @click="addNode">Add Node</button> -->
            <vue-tree-list
              @click="onClick"
              @change-name="onChangeName"
              @delete-node="onDel"
              @add-node="onAddNode"
              @drop="onDrop"
              :model="treeData"
              default-tree-node-name="새 폴더"
              default-leaf-node-name="새 파일"
              v-bind:default-expanded="false">
              <!-- <span class="icon" slot="addTreeNodeIcon">📂</span>
              <span class="icon" slot="addLeafNodeIcon">＋</span>
              <span class="icon" slot="editNodeIcon">📃</span>
              <span class="icon" slot="delNodeIcon">✂️</span> -->
              <!-- <span class="icon" slot="leafNodeIcon">📃</span>
              <span class="icon" slot="treeNodeIcon">📂</span> -->
            </vue-tree-list>
            <!-- <button @click="getNewTree">Get new tree</button> -->
            <!-- <pre>
              {{newTree}}
            </pre> -->
          </div>
        </div>
          <!-- <alarm-sidebar :alarmTags="alarmTags" @closeSidebar="toggleEmailSidebar" :alarmFilter="alarmFilter" /> -->
      </vs-sidebar>
      <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
            <!-- SEARCH BAR -->
          <div class="flex border d-theme-dark-bg items-center">
          <!-- <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" v-if="activeUserLevel >= 3" @click.stop="test(true)"/> -->
            <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleEmailSidebar(true)"/>
            <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="검색"  v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
          </div>
          <!-- EMAIL ACTION BAR -->
        <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
          <div class="flex items-center">
            <!-- <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="select-all-chexkbox ml-0">Select All</vs-checkbox> -->
          </div>
          <div class="flex" :click-not-close="clickNotClose" :hidden-background="clickNotClose">
            <feather-icon v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" icon="EditIcon" class="ml-5 cursor-pointer" svg-classes="h-6 w-6"  @click="activePrompt = true" />
          </div>
        </div>
        <!-- EMAILS LIST -->
        <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" :key="$vs.rtl">
          <transition-group name="list-enter-up" class="email__mails mail__mail-item sm:px-4 px-2 py-6" tag="ul" appear>
            <!-- <li class="cursor-pointer email__mail-item" v-for="(alarm) in alarms" :key="alarm.id" @click="updateOpenAlarm(alarm.id)" >
              <blog-item :alarm="alarm"/>
            </li> -->
          </transition-group>
        </component>
      </div>
      <blog-view
        :isSidebarActive = "isSidebarActive"
        @markUnread      = "activePrompt = true"
        @closeSidebar    = "closeBlogViewSidebar"
        @deleteBlog      = "deleteBlog"/>
    </div>
</template>

<script>
// import { VTree, VSelectTree}  from 'vue-tree-halower'
import BlogItem from "@/views/apps/pms/blog/BlogItem.vue"
import BlogView from "@/views/apps/pms/blog/BlogView.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { VueTreeList, Tree} from 'vue-tree-list'


export default {
  props: ['alarmId'],
  data() {
    return {
      isEmailSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
      newTree: {},
      treeData: null,
      dragDisabled: true,
      activePrompt         : false,
      clickNotClose        : true,
      alarms               : [],
      isSidebarActive      : false,
      fileList             : [],
      searchQuery          : '',
      selectNode           :null,
      fileName:'',
      searchword: '',
    }
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    // currentAlarm() {
    //   return this.$store.getters['alarm/getAlarm'](this.openAlarmId)
    // },
    alarmList() {
      return this.$store.state.alarm.alarms
    },
    activeUserLevel() {
      return this.$store.state.project.ActiveProjectLevel
    },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    ActiveProjectInfo() {
      return this.$store.state.project.ActiveProjectInfo
    },
    blogDir() {
      return this.$store.state.projectBlog.blogDir
    },
    currentBlog(){
      return this.$store.state.projectBlog.activeBlog
    },
    // searchQuery(){
    //   this.$store.commit('alarm/SET_ALARM_SEARCH_QUERY', this.searchQuery)
    //   this.alarms = this.$store.getters['alarm/filteredAlarm']
    // }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false
    },
    windowWidth() {
      this.setSidebarWidth()
    },
    ActiveProjectInfo(){
      this.getBlogDir()
    },
    searchQuery(){
      this.$store.commit('alarm/SET_ALARM_SEARCH_QUERY', this.searchQuery)
      this.alarms = this.$store.getters['alarm/filteredAlarm']
    }
  },
  methods: {
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
        this.fileList = []
      })
    },
    closeBlogViewSidebar() {
      this.isSidebarActive = false
      // this.alarms = this.$store.getters['alarm/filteredAlarm']
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false
      } else {
        this.isEmailSidebarActive = this.clickNotClose = true
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeAlarmViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
    onDrop(params){
      if(params.node.id != params.target.id){
        var children = []
        for (var i in params.target.children){
          children.push(params.target.children[i].id)
        }
        if(children.length != 0){
          this.$store.dispatch('projectBlog/updateProjectBlogNode', {id:params.node.id, name:params.node.name, isleaf:params.node.isLeaf, pid:params.node.pid, parent:params.target.id, children:children}).then(()=>{
          })
        }
      }
    },
    onDel (node) {
      node.remove()
      this.$store.dispatch('projectBlog/deleteProjectBlogNode', node.id).then(()=>{
      })
    },
    onChangeName (params) {
      if (params.eventType =='blur'){
        // console.log(params)
        this.$store.dispatch('projectBlog/updateProjectBlogNodeName',  {id:params.id, name:params.newName}).then(()=>{
        })
      }

    },
    onAddNode (params) {
      // console.log(params)
      this.$store.dispatch('projectBlog/createProjectBlogNode', {name:params.name, isleaf:params.isLeaf, pid:params.pid, parent:params.parent.id, project_id: this.ActiveProjectInfo.id}).then((resolve)=>{
        params.id = resolve.data.data.id
      })
      // console.log('onAddNode')
      // console.log(params)
      // params.id = 5
    },
    onClick (params) {
      this.selectNode = params
      if(params.isLeaf){
        if(!this.currentBlog || params.id != this.currentBlog.pblog_dir_id){
          this.$store.dispatch('projectBlog/getProjectBlog', params.id).then(()=>{
            this.isSidebarActive = true
            if (this.windowWidth < 992) {
              this.clickNotClose = false
              this.isEmailSidebarActive = false
            }
          }).catch(()=>{
            this.isSidebarActive = false
          })
        }else{
          this.isSidebarActive = true
          if (this.windowWidth < 992) {
            this.clickNotClose = false
            this.isEmailSidebarActive = false
          }
        }
      }else{
        this.isSidebarActive = false
      }
    },
    deleteBlog(id){
      if(this.selectNode.id  == id){
        this.selectNode.remove()
        this.selectNode = null
        this.isSidebarActive = false
        this.$store.commit("projectBlog/SET_ACTIVE_BLOG", null)
      }
    },
    addTopNode (node){
      var rootNode = this.treeData.children[0]
      var newNode = new Tree({})
      if(!rootNode.children){
        rootNode.children = []
      }
      newNode.id = node.id
      // newNode.children = node.children
      newNode.isLeaf = node.isleaf
      newNode.parent = rootNode
      newNode.name = node.name
      if(this.activeUserLevel < 2){
        newNode.disabled = true
        newNode.dragDisabled = true
      }
      rootNode.children.push(newNode)
    },
    makeTree(){
      // console.log(this.treeData)
      var treeList = []
      for (var k in this.treeData.children[0].children){
        treeList.push(this.treeData.children[0].children[k])
      }
      while(treeList.length > 0){
        // console.log(index)
        var parentNode  = treeList.pop()
        var parentNodeInfo =  this.$store.getters['projectBlog/getNode'](parentNode.id)
        // console.log(parentNodeInfo)
        for(var i in parentNodeInfo.children){
          var nodeInfo = this.$store.getters['projectBlog/getNode'](parentNodeInfo.children[i])
          var newNode = new Tree({})
          newNode.id = nodeInfo.id
          // newNode.children = nodeInfo.children
          newNode.isLeaf = nodeInfo.isleaf
          newNode.parent = parentNode
          newNode.name = nodeInfo.name
          if(this.activeUserLevel < 2){
            newNode.disabled = true
            newNode.dragDisabled = true
          }
          if(!parentNode.children){
            parentNode.children = []
          }
          parentNode.children.push(newNode)
          treeList.unshift(newNode)
        }
      }
    },
    getBlogDir(){
      if(this.ActiveProjectInfo){
        if(this.activeUserLevel < 2){
          this.treeData = new Tree([{name: this.ActiveProjectInfo.title, id: 0, pid: 0, disabled: true, dragDisabled: true}])
        }else{
          this.treeData = new Tree([{name: this.ActiveProjectInfo.title, id: 0, pid: 0}])
        }
        this.$store.dispatch('projectBlog/getProjectBlogNode', this.ActiveProjectInfo.id).then(()=>{
          for(var index in this.blogDir){
            // console.log(this.blogDir[index])
            if(this.blogDir[index].parent == 0){
              this.addTopNode(this.blogDir[index])
            }else{
              this.makeTree()
              break
            }
          }
        })
      }
    }
  },
  created() {
    // var node = new TreeNode({id:123, name: 'new node', isLeaf: false})
    this.setSidebarWidth()    
    if(this.activeUserLevel < 2){
      this.treeData = new Tree([{name: '없음', id: 0, pid: 0, disabled: true, dragDisabled: true}])
    }else{
      this.treeData = new Tree([{name: '없음', id: 0, pid: 0}])
    }
    this.getBlogDir()
    // this.getBlogDir()
    // console.log(this.treeData)
    // this.treeData = new Tree([{name: 'Node 1', id: 1, pid: 0,
    //         dragDisabled: true,
    //         addTreeNodeDisabled: true,
    //         addLeafNodeDisabled: true,
    //         editNodeDisabled: true,
    //         delNodeDisabled: true,
    //         children: [{name: 'Node 1-2', id: 2, isLeaf: true, pid: 1}]},{name: 'Node 2',id: 3, pid: 0, disabled: true},{name: 'Node 3', id: 4,pid: 0}
    //     ])
  },
  components: {
    'blog-item':BlogItem,
    BlogView,
    VuePerfectScrollbar,
    'VueTreeList':VueTreeList,
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}

button.btn-async{
  background: rgba(var(--vs-warning),0.15);
}

button.btn-delete{
  background: rgba(var(--vs-danger),0.15);
}
</style>

<style lang="less" rel="stylesheet/less">
  .vtl {
    .vtl-drag-disabled {
      background-color: #d0cfcf;
      &:hover {
        background-color: #d0cfcf;
      }
    }
    .vtl-disabled {
      background-color: #d0cfcf;
    }
  }
</style>

<style lang="less" rel="stylesheet/less" scoped>
  .icon {
    &:hover {
      cursor: pointer;
    }
  }
</style>
